import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpWrapperService {

  constructor(private http: Http) { }

  /**
   * Adds default headers including ngrok-skip-browser-warning to every request
   */
  private addDefaultHeaders(options?: RequestOptionsArgs): RequestOptionsArgs {
    if (!options) {
      options = new RequestOptions();
    }
    
    if (!options.headers) {
      options.headers = new Headers();
    }

    // Add the ngrok header to every request
    // options.headers.set('ngrok-skip-browser-warning', 'true');
    
    return options;
  }

  /**
   * GET request with automatic ngrok header
   */
  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.http.get(url, this.addDefaultHeaders(options));
  }

  /**
   * POST request with automatic ngrok header
   */
  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.http.post(url, body, this.addDefaultHeaders(options));
  }

  /**
   * PUT request with automatic ngrok header
   */
  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.http.put(url, body, this.addDefaultHeaders(options));
  }

  /**
   * PATCH request with automatic ngrok header
   */
  patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.http.patch(url, body, this.addDefaultHeaders(options));
  }

  /**
   * DELETE request with automatic ngrok header
   */
  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.http.delete(url, this.addDefaultHeaders(options));
  }

  /**
   * HEAD request with automatic ngrok header
   */
  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.http.head(url, this.addDefaultHeaders(options));
  }

  /**
   * OPTIONS request with automatic ngrok header
   */
  options(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.http.options(url, this.addDefaultHeaders(options));
  }
}
